
import { useAgentChatSocket } from '@/api/agent-chat/useAgentChatSocket';
import ChatRequestList from '../chat-request-list/chat-request-list'
import ConversationHistory from '../conversation-history/conversation-history'

const AgentChatParent = () => {

    const { connectWebSocket, sendMessage, messages, isConnected } = useAgentChatSocket();
    // const { setMessages } = useMessageData();

    console.log(messages)

    return (
        <div className="mt-4 grid grid-cols-4 gap-4">
            <>
                <ChatRequestList className="col-span-4 lg:col-span-1" connectWebSocket={connectWebSocket} sendMessage={sendMessage} isConnected={isConnected} />
            </>
            <div className="col-span-4 lg:col-span-3">
                <>
                    <ConversationHistory sendMessage={sendMessage} messages={messages} />
                </>
            </div>
        </div>
    )
}

export default AgentChatParent